/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualSlug: core.serialization.ObjectSchema<serializers.NotEqualSlug.Raw, Truvity.NotEqualSlug> =
    core.serialization.object({
        value: core.serialization.string(),
    });

export declare namespace NotEqualSlug {
    export interface Raw {
        value: string;
    }
}
